//**************************************************************************************************
//  認証済み確認（システム管理者）ガード
//**************************************************************************************************
//==================================================================================================
//  import
//==================================================================================================
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';

import { SessionService } from '../services/session-service';
//==================================================================================================
//
//==================================================================================================
export const sysAdminGuard: CanActivateFn = (route, state) => {
  const sessionService: SessionService = inject(SessionService);
  const router: Router = inject(Router);

  return sessionService.checkLoginState().pipe(map(session => {
    if (!session.isLogin) {
      return router.createUrlTree(['/login']);
    } else {
      if (!!session.sysAdmin) {
        return true;
      } else {
        sessionService.logout();
        return false;
      }
    }
  }));
};
